export default __webpack_public_path__ + "static/media/email.b1cb2a7f.png";